import { Component } from '@angular/core';

import { MonthlyInvoice } from '../../../../../express-tRPC/src/api/monthly_invoices/types';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { dropdownOption } from '../../types/common';
import { Account, Suite } from '../../../../../express-tRPC/src/api/invoices/types';
import { environment } from '../../../environments/environment';
import { Invoice } from '../../../../../express-tRPC/src/shared/types';

@Component({
  selector: 'app-batch-output-invoices',
  templateUrl: './batch-output-invoices.component.html',
  styleUrl: './batch-output-invoices.component.scss'
})
export class BatchOutputInvoicesComponent {

  env = environment;
  invoices: Invoice[] = [];
  totalInvoices: number = 0;
  isInvoicelistLoading: boolean = false;
  searchOptionsLoading: boolean = false;

  searchOptions: dropdownOption[] = [
    { name: "All Invoices", code: 'all' },
    { name: "Open Invoices", code: 'Open' },
    { name: "Invoices by Month", code: 'billingMonth' },
    { name: "Invoices by Date", code: 'date' },
    { name: "Invoices by Date Range", code: 'dateRange' },
    { name: "Invoices by Suite", code: 'suite' },
    { name: "Invoices by Suite / Account", code: 'suiteAcct' },
    { name: "Open Invoices by Suite", code: 'suiteOpen' },
    { name: "Open Invoices by Suite / Account", code: 'suiteAcctOpen' },
  ];
  suiteOptions: dropdownOption[] = [];
  suiteAcctOptions: dropdownOption[] = [];

  searchBy: string = 'Open';
  searchByBillingMonth: Date = new Date();
  searchByDate: Date = new Date();
  searchByRangeDates: Date[] = [new Date(), new Date()];
  searchBySuite: string = '';
  searchBySuiteAcct: string = '';

  minDate: Date;

  isProcessingInvoices: boolean = false;
  selectAll: boolean = false;

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService
  ) {
    let date = new Date();

    this.minDate = new Date();
    this.minDate.setMonth(date.getMonth() + 1);
    this.minDate.setFullYear(date.getFullYear() - 5);

    this.searchInvoices();
  }


  async getInvoices(event?: TableLazyLoadEvent) {

    this.isInvoicelistLoading = true;
    let invoicesResult: any = await this.trpcService.trpc.invoice.getBatchInvoices.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    this.invoices = invoicesResult;
    this.totalInvoices = invoicesResult?.length || 0;
    this.isInvoicelistLoading = false;

  }

  async searchInvoices() {

    this.isInvoicelistLoading = true;
    let searchdata: string = '';
    let searchDataSecond: string = '';

    if (this.searchBy == "billingMonth") {
      let month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      searchdata = (month[this.searchByBillingMonth.getMonth()] + "-" + this.searchByBillingMonth.getFullYear())
    }
    if (this.searchBy == "date") {
      searchdata = (this.searchByDate.getMonth() + 1) + "/" + this.searchByDate.getDate() + "/" + this.searchByDate.getFullYear();
    }

    if (this.searchBy == "dateRange") {
      searchdata = (this.searchByRangeDates[0].getMonth() + 1).toString().padStart(2, '0') + "/" + this.searchByRangeDates[0].getDate().toString().padStart(2, '0') + "/" + this.searchByRangeDates[0].getFullYear().toString().substr(-2);
      searchDataSecond = (this.searchByRangeDates[1].getMonth() + 1).toString().padStart(2, '0') + "/" + this.searchByRangeDates[1].getDate().toString().padStart(2, '0') + "/" + this.searchByRangeDates[1].getFullYear().toString().substr(-2);
    }

    if (this.searchBy == "suite" || this.searchBy == "suiteOpen" || this.searchBy == "suiteAcct" || this.searchBy == "suiteAcctOpen") {
      searchdata = this.searchBySuite;
      if (this.searchBy == "suiteAcct" || this.searchBy == "suiteAcctOpen") {
        searchDataSecond = this.searchBySuiteAcct;
      }
    }

    console.log(this.searchBy, searchdata, searchDataSecond)
    let invoicesResult: any = await this.trpcService.trpc.invoice.searchInvoice.query({ searchoption: this.searchBy, searchdata: searchdata, searchDataSecond: searchDataSecond }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

    this.invoices = invoicesResult;
    this.totalInvoices = invoicesResult?.length || 0;

    this.isInvoicelistLoading = false;
  }

  async getAccountBySuite(): Promise<void> {

    this.searchBySuiteAcct = '';
    this.suiteAcctOptions = [];

    if (this.searchBySuite && (this.searchBy == "suiteAcct" || this.searchBy == "suiteAcctOpen")) {

      this.searchOptionsLoading = true;

      let acctsResult: any = await this.trpcService.trpc.invoice.getAccounts.query({ suite: this.searchBySuite }).catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });
      if (acctsResult?.length) {
        this.suiteAcctOptions = acctsResult.map((acct: Account) => { return { code: acct.account_number, name: (acct.account_number + ' (' + acct.name + ')') } })
      }
      this.searchOptionsLoading = false;
    }
  }

  async getSearchOptions(event: any) {

    if ((event.value == "suite" || event.value == "suiteAcct" || event.value == "suiteOpen" || event.value == "suiteAcctOpen") && !this.suiteOptions?.length) {
      this.searchOptionsLoading = true;
      let suitesResult: any = await this.trpcService.trpc.invoice.getSuites.query().catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });
      if (suitesResult?.length) {
        this.suiteOptions = suitesResult.map((suite: Suite) => { return { code: suite.suite, name: suite.suite } })
      }
      this.searchOptionsLoading = false;
    }
  }

  checkAllInvoice() {
    this.invoices = this.invoices.map((inv) => {
      if (inv.batch_ran == '') {
        inv.output = this.selectAll;
      }
      return inv;
    });
  }

  get getSelectedInvoiceCount() {
    const selectedInvoices = this.invoices.filter((inv) => inv.batch_ran == '' && inv.output);
    return selectedInvoices.length;
  }

  async processBatchInvoices() {

    this.messageService.clear();

    const eligibleInvoices = this.invoices.filter((invoice: Invoice) => invoice?.output && !invoice.batch_ran);

    if (eligibleInvoices.length === 0) {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "No invoices are selected.",
      });
      return;
    }

    this.isProcessingInvoices = true;

    // Set the selected invoices to all eligible invoices
    const selectedInvoices = eligibleInvoices.map((inv: Invoice) => String(inv.id));

    try {
      const result = await this.trpcService.trpc.invoice.batchPrintInvoice.mutate(
        selectedInvoices
      );

      if (result) {
        this.messageService.add({
          key: "batch-invoice-result",
          summary: 'Success',
          severity: 'success',
          detail: 'The selected invoices have been submitted successfully.',
          closable: false,
          sticky: true
        });
        this.getInvoices();
      }
    } catch (error: any) {
      this.messageService.add({
        key: "batch-invoice-result",
        severity: "error",
        summary: "Error",
        detail: error.message || "Failed to process invoices",
      });
      this.isProcessingInvoices = false;
    }

  }

  async viewInvoice(invoiceId: number) {

    this.messageService.clear();

    try {
      this.isInvoicelistLoading = true;
      let invoiceResult = await this.trpcService.trpc.invoice.viewInvoice.query({ invoice: invoiceId });

      if (invoiceResult) {
        const byteCharacters = atob(invoiceResult.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: "application/pdf" });
        window.open(window.URL.createObjectURL(blob), "_blank", "top=100,left=100,width=600,height=500,status=yes,resizable=yes,scrollbars=yes,location=no");
      }

    } catch (error: any) {
      this.messageService.add({
        key: "batch-invoice-result",
        severity: "error",
        summary: "Error",
        detail: error.message || "Failed to download invoice.",
      });
    } finally {
      this.isInvoicelistLoading = false;
    }
  }

  async downloadBatchInvoice(invoiceId: number) {

    this.messageService.clear();

    try {
      this.isInvoicelistLoading = true;
      let invoiceResult = await this.trpcService.trpc.invoice.downloadBatchInvoice.query({ invoice: invoiceId });

      if (invoiceResult) {
        const byteCharacters = atob(invoiceResult.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: "application/pdf" });
        window.open(window.URL.createObjectURL(blob), "_blank", "top=100,left=100,width=600,height=500,status=yes,resizable=yes,scrollbars=yes,location=no");
      }

    } catch (error: any) {
      this.messageService.add({
        key: "batch-invoice-result",
        severity: "error",
        summary: "Error",
        detail: error.message || "Failed to download batch invoice.",
      });
    } finally {
      this.isInvoicelistLoading = false;
    }
  }

  async voidInvoice(invoiceId: number) {

    this.messageService.clear();

    try {

      const confirmMessage = `Are you sure you want to void invoice(${invoiceId}) ?`;

      if (!confirm(confirmMessage)) {
        return;
      }

      this.isInvoicelistLoading = true;
      let invoiceResult = await this.trpcService.trpc.invoice.voidInvoice.query({ invoice: invoiceId });

      if (invoiceResult) {
        this.messageService.add({
          key: "batch-invoice-result",
          summary: 'Success',
          severity: 'success',
          detail: `Invoice ${invoiceId} voided successfully`,
          closable: false,
          sticky: true
        });
        this.getInvoices();
      }

    } catch (error: any) {
      this.messageService.add({
        key: "batch-invoice-result",
        severity: "error",
        summary: "Error",
        detail: error.message || "Failed to download invoice.",
      });
      this.isInvoicelistLoading = false;
    }
  }

  async requestVoid(invoiceId: number, reason: string, event: Event, overlayPanel: any) {

    overlayPanel.toggle(event);

    this.messageService.clear();

    try {

      if (!reason) {
        this.messageService.add({
          key: "batch-invoice-result",
          severity: "error",
          summary: "Error",
          detail: "Provide a reason.",
        });
        return;
      }

      this.isInvoicelistLoading = true;
      let invoiceResult = await this.trpcService.trpc.invoice.requestInvoice.query({ invoice: invoiceId, reason: reason });

      if (invoiceResult) {
        this.messageService.add({
          key: "batch-invoice-result",
          summary: 'Success',
          severity: 'success',
          detail: `Invoice ${invoiceId} void request saved successfully`,
          closable: false,
          sticky: true
        });
        this.getInvoices();
      }

    } catch (error: any) {
      this.messageService.add({
        key: "batch-invoice-result",
        severity: "error",
        summary: "Error",
        detail: error.message || `Failed to save invoice ${invoiceId} void request.`,
      });
      this.isInvoicelistLoading = false;
    }
  }

  /**
   * Handles the bill status button click event
   * @param event - The click event
   * @param overlayPanel - Reference to the overlay panel
   * 
   **/
  voidRequestClick(event: Event, overlayPanel: any): void {
    overlayPanel.toggle(event);
  }
}
